import { Moment } from "moment";
import { ActionType } from "typesafe-actions";

import { TripClass } from "../common_types";

import * as actions from "./actions";

export type GateTesterAction = ActionType<typeof actions>;

export interface FlightsRequest {
  origin: string;
  destination: string;
  departureDate: Moment;
  returnDate?: Moment;
  partner?: string;
  password?: string;
  adultsPassengers: number;
  childrenPassengers?: number;
  infantsPassengers?: number;
  tripClass: TripClass;
  locale?: string;
  currency?: string;
  url: string;
}

export interface BookingsRequest {
  dateFrom: Moment;
  dateTo: Moment;
  partner?: string;
  password?: string;
  url: string;
}

export enum GateTesterActionTypes {
  FLIGHTS_FETCH_REQUEST = "@GateTester/FLIGHTS_FETCH_REQUEST",
  FLIGHTS_FETCH_SUCCESS = "@GateTester/FLIGHTS_FETCH_SUCCESS",
  FLIGHTS_FETCH_ERROR = "@GateTester/FLIGHTS_FETCH_ERROR",

  BOOKINGS_FETCH_REQUEST = "@GateTester/BOOKINGS_FETCH_REQUEST",
  BOOKINGS_FETCH_SUCCESS = "@GateTester/BOOKINGS_FETCH_SUCCESS",
  BOOKINGS_FETCH_ERROR = "@GateTester/BOOKINGS_FETCH_ERROR",
}

export interface GateTesterError {
  count: number;
  message: string;
  examples: Array<string>;
  field: string;
}

export interface GateTesterFormError {
  errors: {
    origin?: string;
    destination?: string;
    departureDate?: string;
    returnDate?: string;
    adults?: string;
    children?: string;
    infants?: string;
    tripClass?: string;
    locale?: string;
    currency?: string;
    url?: string;
    dateFrom?: string;
    dateTo?: string;
  };
}

export type FetcherErrorType =
  | "fetch_request_failed"
  | "invalid_response_status"
  | "empty_response_body"
  | "unknown_content_type"
  | "response_parsing_error";

export interface GateTesterResult {
  validationErrors: Array<GateTesterError>;
  fetcherError?: {
    type: FetcherErrorType;
    message: string;
  };
  fetcherResult: {
    contentType: string;
    statusCode: number;
    url: string;
  };
  objectsCount: number;
}

export interface GateTesterState {
  readonly flights: {
    errors?: GateTesterFormError;
    result?: GateTesterResult;
    isLoading: boolean;
  };
  readonly bookings: {
    errors?: GateTesterFormError;
    result?: GateTesterResult;
    isLoading: boolean;
  };
}
